import React from 'react';
import { Link } from 'gatsby';
import { useLocation } from '@gatsbyjs/reach-router';
import { TabBarContainer, TabBarItem, type TabBarItemProps } from '@periodica/ui-kit';

import {
  Home as HomeIcon,
  MagnifyingGlass as CatalogIcon,
  SquaresFour as ProjectIcon,
  ShoppingCard as CartIcon,
  Profile as ProfileIcon,
} from '@periodica/ui-kit/icons';
import * as styles from './TabBar.module.css';

export function TabBar() {
  const location = useLocation();
  const { pathname } = location;
  const tabBarItems: TabBarItemProps[] = [
    {
      icon: <HomeIcon />,
      text: 'Главная',
      isActive: pathname === '/',
      render: <Link to="/" />,
    },
    {
      icon: <CatalogIcon />,
      text: 'Каталог',
      isActive: pathname === '/products' || pathname === '/products/',
      render: <Link to="/products" />,
    },
    {
      icon: <ProjectIcon />,
      text: 'Проекты',
      render: <a href="https://web.periodica.press/projects" />,
    },
    {
      icon: <CartIcon />,
      text: 'Корзина',
      render: <a href="https://web.periodica.press/cart" />,
    },
    {
      icon: <ProfileIcon />,
      text: 'Профиль',
      render: <a href="https://web.periodica.press/account" />,
    },
  ];

  return (
    <div className={styles.main}>
      <TabBarContainer>
        {tabBarItems.map((item) => (
          <TabBarItem key={`tab-bar-item_${item.text}`} {...item} />
        ))}
      </TabBarContainer>
    </div>
  );
}
